import { Link } from "react-router-dom";
import { SCHOLAR_ENABLED } from "@/lib/features";
import { BookOpen, Heart } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[var(--color-midnight)] text-[var(--color-cream)]/60 border-t border-[var(--color-gold)]/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-4">
              <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-[var(--color-gold)] to-[var(--color-gold-dim)] flex items-center justify-center">
                <BookOpen className="w-5 h-5 text-[var(--color-midnight)]" />
              </div>
              <span className="text-[var(--color-cream)] font-[var(--font-display)] text-lg font-semibold">
                Deen Over Dunya
              </span>
            </Link>
            <p className="text-sm leading-relaxed">
              Authentic Islamic knowledge, verified through authentic chains of
              narration and scholarly consensus.
            </p>
          </div>

          {/* Explore */}
          <div>
            <h4 className="text-[var(--color-gold)] font-semibold text-sm uppercase tracking-wider mb-4">
              Explore
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/seerah" className="hover:text-[var(--color-cream)] transition-colors">Seerah Explorer</Link></li>
              <li><Link to="/timeline" className="hover:text-[var(--color-cream)] transition-colors">World Timeline</Link></li>
              <li><Link to="/quran" className="hover:text-[var(--color-cream)] transition-colors">Quran Companion</Link></li>
              <li><Link to="/isnad" className="hover:text-[var(--color-cream)] transition-colors">Isnad Explorer</Link></li>
              <li><Link to="/dhikr" className="hover:text-[var(--color-cream)] transition-colors">Dhikr Companion</Link></li>
            </ul>
          </div>

          {/* Learn */}
          <div>
            <h4 className="text-[var(--color-gold)] font-semibold text-sm uppercase tracking-wider mb-4">
              Learn
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/clarifier" className="hover:text-[var(--color-cream)] transition-colors">Misconception Clarifier</Link></li>
              <li><Link to="/learning" className="hover:text-[var(--color-cream)] transition-colors">Learning Paths</Link></li>
              <li><Link to="/scholar" className="hover:text-[var(--color-cream)] transition-colors">Ask a Scholar{!SCHOLAR_ENABLED && " (coming soon)"}</Link></li>
              <li><Link to="/analytics" className="hover:text-[var(--color-cream)] transition-colors">Analytics</Link></li>
              <li><Link to="/bookmarks" className="hover:text-[var(--color-cream)] transition-colors">Bookmarks</Link></li>
              <li><Link to="/settings" className="hover:text-[var(--color-cream)] transition-colors">Settings</Link></li>
            </ul>
          </div>

          {/* Methodology */}
          <div>
            <h4 className="text-[var(--color-gold)] font-semibold text-sm uppercase tracking-wider mb-4">
              Our Methodology
            </h4>
            <p className="text-sm leading-relaxed">
              Every piece of content is traced back to its source through
              authenticated chains of narration (isnad) and verified by
              classical scholarly consensus.
            </p>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-[var(--color-gold)]/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs">
            © {new Date().getFullYear()} Deen Over Dunya. Built with{" "}
            <Heart className="w-3 h-3 inline text-[var(--color-burgundy-light)]" />{" "}
            for the Ummah.
          </p>
          <p className="text-xs font-arabic text-[var(--color-gold)]/60">
            بِسْمِ اللَّهِ الرَّحْمَنِ الرَّحِيمِ
          </p>
        </div>
      </div>
    </footer>
  );
}
